export function shouldUseLocalMasterData (config, user) {
  const roles = user && Array.isArray(user.roles) ? user.roles : []
  const databases = config && Array.isArray(config.databases) ? config.databases : []
  const masterData = databases.find(db => db.name === 'master-data')

  if (!masterData || !masterData.syncOnId) return false
  if (!Array.isArray(masterData.requiredRoles) || !masterData.requiredRoles.some(role => roles.includes(role))) {
    return false
  }

  // Backend wrap-id-dispenser rejects users who have BOTH `feature:online-offline`
  // and `feature:orders:warehouse` with a 400. If we returned true here those
  // users would attempt local sync, fail the id-dispenser call, and silently
  // fall back to remote, so it's better to skip local sync up front.
  if (roles.includes('feature:online-offline') && roles.includes('feature:orders:warehouse')) {
    return false
  }

  // Global-shipments users fetch master-data online, except warehouse users
  // who still sync locally (mirrors backend master-data dispenser).
  const isGlobalShipmentsOnly =
    roles.includes('feature:global-shipments') &&
    !roles.includes('feature:orders:warehouse')

  return !isGlobalShipmentsOnly
}
